<template>
  <div>
    <div class="comm_gridTop_wrap">
      <div class="btn_wrapL">
        <div class=" totalList">
          {{ $t("MSG_TXT_LST_CNT").replace('{0}', fileTotalCount) }}
        </div>
      </div>
      <div
        v-if="getConfigValue('CFG_CMD_ATTH_ID_DISP_YN') === 'Y'"
        class="hidden"
      >
        &nbsp;&nbsp;{{ ` ${attachGroupId}` }}
      </div>

      <div class="btn_wrapR">
        <sui-button
          v-if="downloadHistoryManagementYn === 'Y' && showDnHistoryBtn"
          type="button"
          class="comm_btn_gridTop"
          style="margin-top:2px;margin-right:5px;"
          :title="$t('MSG_BTN_DLOAD_HIS')"
          @click="onClickShowDnHistoryPopup"
        >
          {{ $t('MSG_BTN_DLOAD_HIS') }}
        </sui-button>
        <div
          v-tooltip-white="{ref: 'tooltipHtml'}"
          class="info_tooltip"
        />
        <div
          ref="tooltipHtml"
          class="tooltip-content"
          style="border-style: none;"
        >
          <p>*{{ $t('MSG_TXT_PSBL_ATTH_FILE_EXTS') }}</p>
          <table>
            <tr>
              <th>{{ $t('MSG_TXT_ALL') }}</th><td>{{ getConfigValue('CFG_CMD_ATTH_PSBL_EXTS_ALL') }}</td>
            </tr>
            <tr>
              <th>{{ $t('MSG_TXT_DOC') }}</th><td>{{ getConfigValue('CFG_CMD_ATTH_PSBL_EXTS_PDF') }}</td>
            </tr>
            <tr>
              <th>{{ $t('MSG_TXT_IMG') }}</th><td>{{ getConfigValue('CFG_CMD_ATTH_PSBL_EXTS_IMG') }}</td>
            </tr>
          </table>
        </div>
        <div class="info">
          {{ fileTotalSize | convertToFileSizeFormat }} / {{ attachRestrictionSize }} MB
        </div>
      </div>
    </div>
    <div class="comm_scroll_TB">
      <div class="comm_ListTB">
        <table
          width="100%"
          border="0"
        >
          <colgroup>
            <col width="50px">
            <col width>
            <col
              v-if="getColumnShow(2)"             
            >
            <col
              v-if="getColumnShow(3)"
              width="85px"
            >
            <col
              v-if="getColumnShow(4)"
              
            >
            <col
              v-if="getColumnShow(5)"
              width="60px"
            >
          </colgroup>
          <thead>
            <tr class="header">
              <th><div>No.</div></th>
              <th><div>{{ $t('MSG_TXT_ATTH_ITEM_NM') }}</div></th>
              <th
                v-if="getColumnShow(2) || getColumnShow(3)"
                :colspan="( getColumnShow(2) && getColumnShow(3)) ? 2:1"
              >
                <div>{{ $t('MSG_TIT_ATTH_FILE_NM') }}</div>
              </th>
              <th v-if="getColumnShow(4)">
                <div>{{ $t('MSG_TIT_ATTH_EXID_RSN') }}</div>
              </th>
              <th v-if="getColumnShow(5)">
                <div>{{ $t('MSG_TIT_FORM_SRCH') }}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(itm, itmIndex) in attachGroupItemList">
              <!-- 첨부항목별 첫번째 row에 대한 rowspan 처리 -->
              <tr :key="itm.attachItemId + '_' + itmIndex">
                <!-- No. -->
                <td
                  :rowspan="Math.max( itm.attachFileList.length,1)"
                  :title="itmIndex + 1"
                >
                  {{ itmIndex + 1 }}
                </td>
                <!-- 첨부항목명 -->
                <td class="ellip"
                  :rowspan="Math.max( itm.attachFileList.length,1)"
                  :class="{'star': itm.headquarterEssentialYn == 'Y'}"
                  :title="itm.attachItemName"
                >
                {{ itm.attachItemName }}                 
                </td>
                <!-- 첨부파일이 존재할 경우 - 첨부파일명 -->
                <template v-if="getColumnShow(2)">
                  <td
                    v-if="itm.attachFileList.length > 0"
                   >
                    <!-- db saved file -->
                    <a
                      v-if="itm.attachFileList[0].fileUid"
                      :class="getFileExtensionIconClass(itm.attachFileList[0].fileExtensionName)"
                      href="#none"
                      :title="itm.attachFileList[0].fileName"
                      @click.prevent="clickOnFileName(itm.attachFileList[0])"
                    > {{ itm.attachFileList[0].fileName }}</a>
                    
                    <!-- temp saved file -->
                    <span class="name"
                      v-if="!itm.attachFileList[0].fileUid"
                      :class="getFileExtensionIconClass(itm.attachFileList[0].fileExtensionName)"
                      :title="itm.attachFileList[0].fileName"
                    >{{ itm.attachFileList[0].fileName }}</span>
                    <span class="size">({{ itm.attachFileList[0].fileSize | convertToFileSizeFormat }})</span>
                    <sui-button
                      v-if="!disabled"
                      type="button"
                      class="btn_list_del"
                      :disabled="disabled"
                      @click="clickOnDeleteBtn(itm, 0)"
                    >
                      {{ $t('MSG_BTN_DEL') }}
                    </sui-button>
                  </td>
                  <!-- 첨부파일이 없을 경우 - {0}을 첨부해 주세요. -->
                  <td
                    v-if="itm.attachFileList.length == 0"
                    class="preview"
                  >
                    <!--eslint-disable-next-line-->
                  {{ itm.attachPossibilityExtensionCode|convertFileExtCodeMessage }}
                  </td>
                </template>
                <!-- 파일찾기 버튼 -->
                <td class="ta_c"
                  v-if="getColumnShow(3)"
                  style="text-overflow:clip"
                  :rowspan="Math.max( itm.attachFileList.length,1)"
                >
                  <sui-button
                    type="button"
                    class="comm_sbtn_border"
                    :disabled="disabled"
                    @click="clickOnSelectFile(itm)"
                  >
                    {{ $t('MSG_BTN_SCH_FILE') }}
                  </sui-button>
                </td>
                <!-- 첨부제외사유 -->
                <td
                  v-if="getColumnShow(4)"
                  :rowspan="Math.max( itm.attachFileList.length,1)"
                >
                  <sui-text-field
                    v-model="itm.attachExcludeReasonContent"
                    :placeholder="$t('MSG_TXT_ATTH_EXID_RSN_INP')"
                    :disabled="disabled || itm.attachExcludePossibilityYn=='N' || itm.attachFileList.length !== 0"
                    :readonly="readonly"
                  />
                </td>
                <!-- 양식조회 버튼 -->
                <td class="ta_c"
                  v-if="getColumnShow(5)"
                  style="text-overflow:clip"
                  :rowspan="Math.max( itm.attachFileList.length,1)"
                >
                  <sui-button
                    type="button"
                    class="comm_sbtn_border"
                    :disabled="utilsTrim(itm.standardFormId) == ''"
                    @click="clickOnSearchStdFormBtn(itm)"
                  >
                    {{ $t('MSG_BTN_SRCH') }}
                  </sui-button>
                </td>
              </tr>
              <!-- 첨부항목별 두번째 row부터 처리 -->
              <template v-for="(_file, fileIndex) in itm.attachFileList">
                <tr
                  v-if="fileIndex > 0"
                  :key="itm.attachItemId + '_' + itmIndex + '_' + fileIndex"
                >
                  <td
                    v-if="getColumnShow(2)"
                    class="file btn_list_del"
                  >
                    <a
                      v-if="_file.fileUid"
                      :class="getFileExtensionIconClass(_file.fileExtensionName)"
                      href="#none"
                      :title="_file.fileName"
                      @click="clickOnFileName(_file)"
                    >{{ _file.fileName }}</a>
                    <span class="name"
                      v-if="!_file.fileUid"
                      :class="getFileExtensionIconClass(_file.fileExtensionName)"
                      :title="_file.fileName"
                    >{{ _file.fileName }}</span>
                    <span class="size">
                      ({{ _file.fileSize | convertToFileSizeFormat }})</span>
                    <sui-button
                      v-if="!disabled"
                      type="button"
                      class="btn_list_del"
                      :disabled="disabled"
                      @click="clickOnDeleteBtn(itm, fileIndex)"
                    >
                      {{ $t('MSG_BTN_DEL') }}
                    </sui-button>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <input
      v-show="false"
      ref="inputFileType"
      type="file"
      multiple
      accept="*"
      class="input-file"
      title=" "
      @change="onFilesChange($event.target.files)"
    >
  </div>
</template>

<script>

export default {
  name: 'CmpFileAttachItemManager',
  filters: {
    /**
     * 파일 사이즈를 KB, MB 단위로 계산해서 단위와 함께 반환함
     * @function convertToFileSizeFormat
     * @param {Number} size: 변환대상 숫자
     * @returns {String} "123.45 KB" or "6.78 MB"
     */
    convertToFileSizeFormat(value) {
      let unit = ''; // 'KB' or 'MB'
      let resultVal = 0;

      if (value === 0) {
        resultVal = 0;
        unit = 'KB';
      } else if (value < 1024) {
        // 1024 byte 이하이면 항상 1 KB
        resultVal = 1;
        unit = 'KB';
      } else if (value > 1024 * 1024) {
        resultVal = value / (1024 * 1024);
        unit = 'MB';
      } else {
        resultVal = value / (1024);
        unit = 'KB';
      }
      return `${utils.numberFormat(resultVal, 2)} ${unit}`;
    },
    convertFileExtCodeMessage(value) {
      let _message = utils.getMessageById('MSG_ALT_ATTH_FILE');
      switch (value) {
        case 'ALL':
          _message = _message.replace('{0}', '');
          break;
        case 'PDF':
          _message = _message.replace('{0}', utils.getMessageById('MSG_TXT_DOC'));
          break;
        case 'IMG':
          _message = _message.replace('{0}', utils.getMessageById('MSG_TXT_IMG'));
          break;
        default:
          _message = _message.replace('{0}', '');
          break;
      }
      return _message;
    },
  },
  props: {
    // 이 컴포넌트를 사용하는 페이지ID
    pageId: {
      type: String,
      required: true,
      default() {
        return '';
      },
    },
    // 첨부그룹ID
    attachGroupId: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
    // 첨부문서ID
    attachDocumentId: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
    // colum index 로 칼럼숨김 제어
    hideColumns: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    readonly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showDnHistoryBtn: {
      type: Boolean,
      default() {
        return false;
      },
    },
    myFileYn: {
      type: String,
      default() {
        return 'N';
      },
    },
  },
  data() {
    return {
      attachRestrictionSize: 0, // 총 파일 사이즈 제한 크기
      downloadReasonInputYn: null, // 다운로드 사유 입력여부
      downloadHistoryManagementYn: null, // 다운로드 이력관리 여부
      attachGroupItemList: [], // 조회된 첨부그룹항목 목록에 대한 참조값 저장

      // tootlip options - 이 컴포넌트를 한 화면에서 2개 이상 쓸 경우에
      // id를 하드코딩하지 않고 중복되지 않도록 만들기 위하여 변수로 빼고 바인딩하는 방법을 사용할 수 밖에 없음
      // tooltipOptions: { html: `id${Math.round(Math.random() * 1000)}_${Math.round(Math.random() * 1000)}` },

      // 파일찾기 버튼 click 시 해당 버튼이 위치하는 파일항목에 대한 참조값 저장
      // 파일 선택시 해당 위치로 append 하기 위해 사용
      currentAttachItem: '',
    };
  },
  computed: {
    fileTotalSize() {
      let totalSize = 0;
      this.attachGroupItemList.forEach(itm => {
        itm.attachFileList.forEach(file => {
          totalSize = totalSize * 1 + file.fileSize * 1;
        });
      });
      return totalSize;
    },
    fileTotalCount() {
      let totalCount = 0;
      this.attachGroupItemList.forEach(itm => {
        if (!utils.isEmpty(itm.attachFileList)) {
          totalCount += itm.attachFileList.length;
        }
      });
      return totalCount;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    attachGroupId(value) {
      this.searchAttachGroupItemList().then(res => {
        //
      }).catch(err => console.log(err));
    },
    // eslint-disable-next-line no-unused-vars
    attachDocumentId(value) {
      this.searchAttachGroupItemList().then(res => {
        //
      }).catch(err => console.log(err));
    },
  },
  mounted() {
    // 바인딩된 첨부항목ID 와 첨부문서ID 로 목록 조회
    this.searchAttachGroupItemList().then(res => {
      //
    }).catch(err => console.log(err));
  },
  methods: {
    utilsTrim(value) {
      return utils.trim(value);
    },
    onClickShowDnHistoryPopup() {
      if (!utils.isEmpty(this.attachGroupId) && !utils.isEmpty(this.attachDocumentId)) {
        utils.openLayerPopup('PGE_CMZ_00070', () => {}, {
          pageInitialData: {
            attachGroupId: this.attachGroupId,
            attachDocumentId: this.attachDocumentId,
          },
          size: 'lg',
        });
      } else {
        console.log(`첨부그룹ID값(${this.attachGroupId})과 첨부문서ID(${this.attachDocumentId})값이 모두 존재해야 합니다.`);
      }
    },
    initData() {
      this.attachGroupItemList = [];
      this.attachRestrictionSize = 0;
      this.downloadReasonInputYn = null;
      this.downloadHistoryManagementYn = null;
      this.currentAttachItem = '';
    },
    reset() {
      this.initData();

      // 바인딩된 첨부항목ID 와 첨부문서ID 로 목록 조회
      this.searchAttachGroupItemList().then(res => {
        //
      }).catch(err => console.log(err));
    },
    /**
     * 파일 확장자를 인수로 받아 그에 맞는 icon에 연결된 class 를 반환한다.
     * @function getFileExtensionIconClass
     * @param {String} fileExtension 파일확장자
     * @returns {String}
     */
    getFileExtensionIconClass(fileExtension) {
      const fileExt = fileExtension.toUpperCase();
      const imageExtArr = utils.getConfigurationValue('CFG_CMD_ATTH_PSBL_EXTS_IMG').replace(/\s/g, '').toUpperCase().split(',');
      let retVal = '';
      if (utils.indexOf(['XLSX', 'XLSM', 'XLTX', 'XLTM', 'XLS', 'XLT'], fileExt) >= 0) {
        retVal = 'excel';
      } else if (utils.indexOf(imageExtArr, fileExt) >= 0) {
        retVal = 'image';
      } else if (utils.indexOf(['PPTX', 'PPTM', 'PPT'], fileExt) >= 0) {
        retVal = 'ppt';
      } else if (utils.indexOf(['DOC', 'DOCX', 'DOCM'], fileExt) >= 0) {
        retVal = 'word';
      } else if (utils.indexOf(['PDF'], fileExt) >= 0) {
        retVal = 'pdf';
      } else {
        retVal = 'etc';
      }
      return retVal;
    },
    /**
     * 스크립틀릿에서는 utils 를 사용할 수 없기 때문에 그것 대체용으로
     */
    getConfigValue(config) {
      return utils.getConfigurationValue(config);
    },
    /**
     * 첨부그룹ID 와 첨부문서ID 에 해당하는 목록정보를 조회한 후 결과를 테이블에 표시한다.
     * @function searchAttachGroupItemList
     * @param {None}
     * @returns {Promise}
     */
    // eslint-disable-next-line consistent-return
    searchAttachGroupItemList() {
      return new Promise((resolve, reject) => {
        this.initData();

        if (utils.isEmpty(this.attachGroupId)) {
          // {0} 은(는) 필수값 입니다.
          return reject(`${this.$t('MSG_ALT_NCELL_REQUIRED_ITEM')}`.replace('{0}', 'attachGroupId'));
        }

        http.request(this.pageId, 'DTS_CMZ_00086', {
          path: {
            'attach-group-id': this.attachGroupId,
          },
          query: {
            attachDocumentId: this.attachDocumentId,
          },
        }).then(res => {

          if (res.data.length > 0) {
            this.attachGroupItemList = res.data;
            this.attachRestrictionSize = this.attachGroupItemList[0].attachRestrictionSize;
            this.downloadReasonInputYn = this.attachGroupItemList[0].downloadReasonInputYn;
            this.downloadHistoryManagementYn = this.attachGroupItemList[0].downloadHistoryManagementYn;
            resolve(res);
          } else {
            utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_NO_ATTH_GRP_DATA').replace('${0}', this.attachGroupId));
            reject(res);
          }
        }, rej => {
          reject(rej);
        }).catch(err => reject(err));
      });
    },
    /**
     * 첨부파일 용량 제한 확인 결과를 반환
     * @function checkAttachFileSizeLimit
     * @param {boolean} 제한사이즈에 걸릴 경우 messageBox 표시 flag - default 값은 true
     * @returns {Promise}
     */
    checkAttachFileSizeLimit(showMessage = true) {
      return new Promise((resolve, reject) => {
        if (this.attachRestrictionSize > 0) {
          // 첨부된 파일 사이즈 총용량
          let totalFileSize = 0;
          this.attachGroupItemList.forEach(itm => {
            itm.attachFileList.forEach(file => {
              totalFileSize += file.fileSize * 1;
            });
          });

          let errorMsg = '';
          if (totalFileSize > (this.attachRestrictionSize * 1024 * 1024)) {
            if (showMessage) {
              // 선택한 파일(들) 용량을 합한 총 파일 용량이 제한 용량({0})을 초과했습니다.
              // eslint-disable-next-line
              errorMsg = utils.strFormat(this.$t('MSG_ALT_ECXD_TTQTY_NCELL'), `${this.getComma(this.attachRestrictionSize)} MB`);
              utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), errorMsg, () => resolve(false));
            } else {
              resolve(false);
            }
          } else {
            resolve(true);
          }
        } else {
          resolve(true);
        }
      });
    },
    /**
     * 첨부파일 용량 제한 확인 결과를 true/false로 반환
     * @function isUnderAttachFileSizeLimit
     * @param {boolean} 제한사이즈에 걸릴 경우 messageBox 표시 flag - default 값은 true
     * @returns {boolean} true/false
     */
    isUnderAttachFileSizeLimit(showMessage = true) {
      let isUnderLimit = true;
      if (this.attachRestrictionSize > 0) {
        // 첨부된 파일 사이즈 총용량
        let totalFileSize = 0;
        this.attachGroupItemList.forEach(itm => {
          itm.attachFileList.forEach(file => {
            totalFileSize += file.fileSize * 1;
          });
        });

        if (totalFileSize > (this.attachRestrictionSize * 1024 * 1024)) {
          if (showMessage) {
            // 선택한 파일(들) 용량을 합한 총 파일 용량이 제한 용량({0})을 초과했습니다.
            // eslint-disable-next-line
            let errorMsg = utils.strFormat(this.$t('MSG_ALT_ECXD_TTQTY_NCELL'), `${this.getComma(this.attachRestrictionSize)} MB`);
            utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), errorMsg);
          }
          isUnderLimit = false;
        }
      }
      return isUnderLimit;
    },
    getColumnShow(colIndex) {
      if (this.hideColumns.indexOf(colIndex) === -1) {
        return true;
      }

      return false;
    },
    /**
     * input type file의 click 이벤트를 발생시켜 file browser 창을 연다.
     *
     * @function onSelectFile
     * @param {Object} currItem: 현재 파일브라우저가 click된 위치의 첨부항목 object에 대한 참조
     * @return  none
     */
    clickOnSelectFile(currItem) {
      if (!utils.isEmpty(currItem.attachExcludeReasonContent)) {
        // 첨부제외사유가 존재합니다.
        utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_EXIST_ATTH_EXLD_RSN'));
      } else {
        this.currentAttachItem = currItem;
        this.$refs.inputFileType.click();
      }
    },
    /**
     * 파일삭제
     * @function clickOnDeleteBtn
     * @param {Object} itm: 첨부항목
     * @param {Integer} fileIndex: 첨부항목의 attachFileList에서 현재 삭제할 파일 index
     * @returns {none}
     */
    clickOnDeleteBtn(itm, fileIndex) {
      itm.attachFileList.splice(fileIndex, 1);
    },
    clickOnSearchStdFormBtn(itm) {
      utils.openLayerPopup('PGE_CMD_00008', () => {}, {
        pageInitialData: {
          standardFormId: itm.standardFormId,
        },
        size: 'md',
      });
    },
    /**
     * 첨부할 파일의 허용가능한 확장자 목록을 반환
     * @function getFileExtWhiteList
     * @param {String} extCode: 첨부항목의 attachPossibilityExtensionCode
     * @returns {Array}
     */
    getFileExtWhiteList(extCode) {
      const configValue = utils.getConfigurationValue(`CFG_CMD_ATTH_PSBL_EXTS_${extCode}`);
      if (utils.isEmpty(configValue)) {
        console.error('첨부가능 확장자에 대한 config 를 찾을 수 없습니다.');
      }
      return configValue.replace(/\s+/g, '').toUpperCase().split(',');
    },
    /**
     * input type file의 change 이벤트 핸들러
     * file browser 에서 파일을 선택한 순간 해당 파일 정보를 기존 파일 목록에 추가한다.
     *
     * @function onFilesChange
     * @param  {Array} fileList : 선택한 파일(들)
     * @return  {none}
     */
    onFilesChange(fileList) {
      const _currentFileList = this.currentAttachItem.attachFileList;
      const _re = /^.+\.(\w*$)/; // 파일 확장자 추출용 정규표현식
      let isPassed = true;
      let errorMsg = '';

      // 확장자가 없는 파일 check
      for (let i = 0; i < fileList.length; i += 1) {
        const reExec = _re.exec(fileList[i].name);
        if (reExec === null) {
          isPassed = false;
          // 확장자가 없는 파일은 첨부 할 수 없습니다.
          errorMsg = this.$t('MSG_ALT_NO_FILE_EXTS');
          break;
        }
      }

      // 확장자 제한 check
      if (isPassed) {
        for (let i = 0; i < fileList.length; i += 1) {
          const reExec = _re.exec(fileList[i].name);
          const extList = this.getFileExtWhiteList(this.currentAttachItem.attachPossibilityExtensionCode);
          if (!extList.includes(reExec[1].toUpperCase())) {
            // 허용 가능한 확장자({0})의 파일을 추가하시기 바랍니다.
            isPassed = false;
            errorMsg = utils.strFormat(this.$t('MSG_ALT_ADD_NCELL_EXTS_FILE'), extList.join(', '));
          }
        }
      }

      // 파일사이즈 제한 check
      if (isPassed && this.attachRestrictionSize > 0) {
        // 기존 파일 사이즈 합
        let _asIsTotal = 0;
        this.attachGroupItemList.forEach(itm => {
          itm.attachFileList.forEach(file => {
            _asIsTotal += file.fileSize * 1;
          });
        });

        // 새로 추가할 파일 사이즈 합
        let _tobeTotal = 0;
        utils.forEach(fileList, file => {
          _tobeTotal += file.size * 1;
        });

        if ((_asIsTotal + _tobeTotal) > (this.attachRestrictionSize * 1024 * 1024)) {
          // 선택한 파일(들) 용량을 합한 총 파일 용량이 제한 용량({0})을 초과했습니다.
          isPassed = false;
          // eslint-disable-next-line
          errorMsg = utils.strFormat(this.$t('MSG_ALT_ECXD_TTQTY_NCELL'), `${this.getComma(this.attachRestrictionSize)} MB`);
        }
      }

      if (isPassed) {
        // handle file changes
        for (let j = 0; j < fileList.length; j += 1) {
          let bDup = false;
          const _file = fileList[j];
          const _ext = _re.exec(_file.name);

          // local 파일 정보와 파일 브라우저에서 선택한 파일정보 비교
          for (let i = 0; i < _currentFileList.length; i += 1) {
            if (_file.name === _currentFileList[i].fileName) {
              bDup = true;
              _currentFileList[i].fileName = _file.name;
              _currentFileList[i].fileSize = _file.size;
              _currentFileList[i].fileExtensionName = _ext.length > 1 ? _ext[1] : '';
              _currentFileList[i].file = _file;
              _currentFileList[i].realityFilePath = ''; // 명이 동일한 파일을 선택한 경우에 다시 올린다.

              break;
            }
          }

          if (!bDup) {
            _currentFileList.push({
              fileName: _file.name,
              fileSize: _file.size,
              fileExtensionName: _ext.length > 1 ? _ext[1] : '',
              file: _file,
            });
          }
        }
        // 파일 선택하자마자 바로 전송
        this.uploadFiles();
      } else {
        utils.messageBox('warning', `${this.$t('MSG_TXT_EXTS')} ${this.$t('MSG_BTN_CFRM')}`, errorMsg);
      }
      // 동일한 파일을 연속 선택시 change 이벤트가 발생하지 않는 문제 해결
      // document.querySelector("input[type='file']").value = '';
      // document.querySelector(`input[name='${this.inputTypeFileName}']`).value = '';
      this.$refs.inputFileType.type = '';
      this.$refs.inputFileType.type = 'file';
    },
    getComma(value) {
      return utils.numberFormat(value, 2);
    },
    /**
     * 파일 업로드 실행
     * 위의 두가지 경우를 고려하여 파일전송시 이미 올라간 파일(realityFilePath 에 값이 있는 놈)을
     * 제외하고 아직 올라가지 않은 파일을 전송해야 함
     * @function uploadFiles
     * @param {None}
     * @return {Promise}
     */
    uploadFiles() {
      const _currentFileList = this.currentAttachItem.attachFileList;

      // 업로드 대상 파일 배열
      const _targetFiles = [];
      _currentFileList.forEach(curFile => {
        if (utils.isEmpty(curFile.realityFilePath)) {
          _targetFiles.push(utils.cloneDeep(curFile));
        }
      });

      // handle file changes
      const formData = new FormData();
      _targetFiles.forEach(fileInfo => {
        formData.append('files', fileInfo.file);
      });

      const params = {
        path: {
          'target-path': 'temp', // 임시 디렉토리로 파일전송
        },
        data: formData,
      };

      // upload data to the server

      http.request(this.pageId, 'DTS_CMZ_00041', params).then(res => {
        // realityFilePath 맵핑
        res.data.forEach(rtnFile => {
          _currentFileList.forEach(curFile => {
            if (rtnFile.originalFileName === curFile.fileName) {
              curFile.realityFilePath = rtnFile.serverFileName; //  eslint-disable-line no-param-reassign
            }
          });
        });

        return Promise.resolve(res);
      }).catch(err => {
        // 파일전송 실패
        console.log(err);
        // 대상 파일들 삭제
        for (let i = _currentFileList.length - 1; i >= 0; i -= 1) {
          _currentFileList.splice(i, 1);
        }
        return Promise.reject(err);
      });
    },
    /**
     * 현재 첨부그룹 항목 목록 정보를 반환한다.
     * attachFileList의 arrayalOrder 값을 매긴다.
     * @function getAttachGroupItemListInfo
     * @returns {Array} : 첨부그룹 항목 의 Object Array
     */
    getAttachGroupItemListInfo() {
      const _tmpFileListInfo = utils.cloneDeep(this.attachGroupItemList);
      _tmpFileListInfo.forEach(itm => {
        itm.attachFileList.forEach((file, index) => {
          file.arrayalOrder = index + 1;//  eslint-disable-line no-param-reassign
          file.attachGroupId = itm.attachGroupId;//  eslint-disable-line no-param-reassign
          file.attachItemId = itm.attachItemId;//  eslint-disable-line no-param-reassign
        });
      });
      return _tmpFileListInfo;
    },
    /**
     * 파일명 click 이벤트 핸들러
     * 해당 file 정보 중 fileUid 가 존재하면 서버 파일, 아니면 로컬 파일
     * 서버 파일이면 file 다운로드, 로컬 파일이면 암것도 하지마!
     * @function clickOnFileName
     * @param {Object} event : cell click event Object
     * @returns {None}
     */
    clickOnFileName(file) {
      const that = this;
      if (!['N', 'n'].includes(this.downloadReasonInputYn)) {
        utils.openLayerPopup('PGE_CMZ_00041', result => {
          file.fileDownloadReasonContent = result;

          if (!utils.isEmpty(result)) {
            that.downloadSingleFile(file).then(() => {
              that.insertFileDownloadHistory(file);
            }).catch(err => {
              console.log(err);
              // utils.messageBox('error', that.$t('MSG_BTN_CFRM'), err);
            });
          }
        },
        {
          size: 'md',
        });
      } else {
        this.downloadSingleFile(file).then(() => {
          if (!['N', 'n'].includes(this.downloadHistoryManagementYn)) {
            this.insertFileDownloadHistory(file);
          }
        }).catch(err => {
          console.log(err);
          // utils.messageBox('error', this.$t('MSG_BTN_CFRM'), err);
        });
      }
    },
    /**
     * @function insertFileDownloadHistory
     * @param {Object} fileInfo
     * @returns {None}
     */
    insertFileDownloadHistory(fileInfo) {
      const _fileInfo = utils.clone(fileInfo);
      _fileInfo.imgSrc = '';
      _fileInfo.attachGroupId = this.attachGroupId;
      _fileInfo.attachDocumentId = this.attachDocumentId;

      // /api/v1/common/download-history
      http.request(this.pageId, 'DTS_CMZ_00103', {
        data: _fileInfo,
      }).then(res => {
        console.log(res);
        return Promise.resolve(res);
      }).catch(err => {
        utils.messageBox('error', this.$t('MSG_BTN_CFRM'), err.message, () => Promise.reject(err));
      });
    },
    /**
     * 파일 다운로드
     * @function downloadSingleFile
     * @param {Object}
     * @returns Promise
     */
    downloadSingleFile(rowData) {
      return new Promise((resolve, reject) => {
        http.request(this.pageId, 'DTS_CMZ_00068', {
          path: {
            'target-path': 'storage',
          },
          query: {
            serverFileName: rowData.realityFilePath,
            originalFileName: rowData.fileName,
            myFileYn: this.myFileYn,
          },
          responseType: 'arraybuffer',
        }).then(res => {
          const { fileName } = rowData;
          utils.downloadBlob(res, fileName);
          resolve(res);
        }).catch(err => {
          console.log(err);
          reject(err);
        });
      });
    },
    /**
     * @function onShowImageViewerPopup
     * @param {Object}
     * @returns None
     */
    onShowImageViewerPopup(file) {
      if (file.type.toUpperCase().startsWith('IMAGE')) {
        if (this.enableImageViewer) {
          utils.openLayerPopup('PGE_CMZ_00014', this.onPagePopupClose, {
            pageInitialData: { file },
            size: 'sm',
            title: 'Image Viewer',
          });
        }
      } else if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(file, file.name);
      } else {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(file);
        link.target = '_blank';
        if (file.name) link.download = file.name;
        link.click();
      }
    },
    checkNotAttachedItem() {
      const _arr = [];
      utils.forEach(this.attachGroupItemList, itm => {
        if (itm.headquarterEssentialYn === 'Y' && utils.isEmpty(itm.attachFileList)) {
          if (itm.attachExcludePossibilityYn !== 'Y'
            || (itm.attachExcludePossibilityYn === 'Y' && utils.isEmpty(itm.attachExcludeReasonContent))) {
            _arr.push(itm);
          }
        }
      });
      return _arr;
    },
    /**
     * @function getNotAttachedItems
     * @param {None}
     * @returns {Array} Object Array
     */
    getNotAttachedItems() {
      const _arr = [];
      utils.forEach(this.attachGroupItemList, itm => {
        if (itm.headquarterEssentialYn === 'Y' && utils.isEmpty(itm.attachFileList)) {
          if (itm.attachExcludePossibilityYn !== 'Y'
            || (itm.attachExcludePossibilityYn === 'Y' && utils.isEmpty(itm.attachExcludeReasonContent))) {
            _arr.push(itm);
          }
        }
      });
      return _arr;
    },
  },
};

</script>

<style scoped>
</style>
